import { getStaticQuotes } from './../common/hard-coded';
import { AppConfig } from './../app.config';
import { SnapshotService } from './../snapshot/snapshot.service';
import { DashboardEventService } from './../dashboard/dashboard-event.service';
import { ServiceRegistry } from './../service/service-registry.service';
import { AwsUtil } from './../authentication/aws.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { BaseRestService } from '../service/base-rest.service';
import {
    GetQuotesRequest,
    WebApiEndpoints,
    Quote,
    QuoteTypes,
    QuoteTenor
} from '@liquitics/transaction';
import { BasePollingRestService } from '../service/base-polling-rest.service';
import { DatePipe } from '@angular/common';

@Injectable()
export class MarketDataService extends BasePollingRestService<Quote[]> {
    private POLLING_INTERVAL = 30000;

    private dataSubject$: Subject<Quote[]>;

    private utcOffset: string;
    private registeredQuoteNames: Set<string> = new Set<string>();
    private quotesMap: Map<string, Quote> = new Map<string, Quote>();

    constructor(protected http: HttpClient,
        protected awsUtil: AwsUtil,
        protected serviceRegistry: ServiceRegistry,
        protected dashboardEventService: DashboardEventService,
        private snapshotService: SnapshotService,
        private datePipe: DatePipe,
        private appConfig: AppConfig) {

        super(http, awsUtil, serviceRegistry, dashboardEventService);
        this.createPollingDataSubject(this.POLLING_INTERVAL);
        this.dataSubject$ = this.getPollingDataSubject() as Subject<Quote[]>;
        this.utcOffset = appConfig.getTenantInfo().utcOffset;
    }

    registerService() {
        this.serviceRegistry.registerService(this);
    }

    getDataSubject() {
        return this.dataSubject$;
    }

    startPolling() {
        super.startPolling();
    }

    registerQuotes(quoteNames: string[]) {
        if (quoteNames) {
            quoteNames.forEach((quoteName: string) => {
                this.registeredQuoteNames.add(quoteName);
            })
        }
    }

    buildPollingRequestParams() {
        const request = new GetQuotesRequest();
        request.quoteNames = Array.from(this.registeredQuoteNames);
        return request;
    }

    postResolveData(quotes: Quote[], params?: any): Quote[] {
        // TEMP
        quotes.push(...getStaticQuotes(this.appConfig.getTodayString()));

        quotes.forEach((quote: Quote) => {
            this.quotesMap.set(quote.name, quote);
        })
        return quotes;
    }

    getAPIName(params?: any): string {
        if (params instanceof GetQuotesRequest) {
            return WebApiEndpoints.QueryQuotes;
        } else {
            return WebApiEndpoints.SaveQuote;
        }
    }

    useDemoDataFile(): boolean {
        return false;
    }

    public saveQuote(quote: Quote): Promise<void> {
        return this.awsUtil.webAPICall(WebApiEndpoints.SaveQuote, quote, true);
    }

    public fetchQuotes(request: GetQuotesRequest): Promise<Quote[]> {
        return this.awsUtil.webAPICall<Quote[]>(WebApiEndpoints.QueryQuotes, request, false);
    }

    public getQuotes(quoteNames: string[], keepBlanks?: boolean): Quote[] {
        return quoteNames.map((quoteName: string) => {
            return this.quotesMap.get(quoteName);
        })
            .filter((quote: Quote) => {
                return keepBlanks || (quote !== null && quote !== undefined);
            })
            ;
    }

    public getSingleRate(quoteName: string, defaultRate?: number) {
        const quote: Quote = this.quotesMap.get(quoteName);
        if (!quote) {
            return defaultRate || 0.0;
        }
        return quote.rate || (defaultRate || 0.0);
    }

    // public getMarketDataItems(baseCurrency: string, currencies: string[]): Promise<MarketData[]> {
    //     const marketDataItems: MarketData[] = [];
    //     return Promise.resolve(marketDataItems);
    // }
    // protected makeAPICall(authToken: string, params?: any): Observable<MarketData[]> {
    //     return this.http.get<MarketData[]>(this.getAPIName(params));
    // }

    // postResolveData(data): MarketData[] {
    //     const cumulatives = {};
    //     data.map(entry => {
    //         entry.fxBidRate = this.round(entry.fxBidRate, 4);
    //         entry.fxAskRate = this.round(entry.fxAskRate, 4);
    //         entry.fxMidRate = this.round(this.computeMid(entry.fxBidRate, entry.fxAskRate), 4);

    //         entry.mmBidRate = this.round(entry.mmBidRate, 4);
    //         entry.mmAskRate = this.round(entry.mmAskRate, 4);
    //         entry.mmMidRate = this.round(this.computeMid(entry.mmBidRate, entry.mmAskRate), 4);
    //     });
    //     return data;
    // }

    // getData(currencies: string[]) {
    //     return super.getDataObservable(currencies);
    // }

    // randomValue(baseValue: number) {
    //     const diceRoll = Math.random();
    //     if (diceRoll > 0.9) {
    //         return baseValue * ((Math.random() * .4) + 0.8);
    //     } else {
    //         return baseValue;
    //     }
    // }

    computeMid(bidRate: number, askRate: number) {
        return (bidRate + askRate) / 2;
    }

    round(n: number, d: number) {
        const scale = Math.pow(10, d);
        return Math.round(n * scale) / scale;
    }
}
